import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const ResultList = lazy(() => import('Containers/Lab/ResultList/ResultList'));
const ResultDetails = lazy(() => import('Containers/Lab/ResultDetails/ResultDetails'));

const routes = [
  {
    path: '/lab-results',
    exact: true,
    ContentComponent: ResultList,
    Layout: MainLayout,
    name: 'Lab Results',
  },
  {
    path: '/lab-results/:id',
    exact: true,
    ContentComponent: ResultDetails,
    Layout: MainLayout,
    name: 'Lab Results',
  },
];

export default routes;
